import './HistoryTab.css';
import FindingsPanel from './FindingsPanel';

/**
 * Audit History tab.
 *
 * The old per-session detail list (licence checks / dual-use analyses / uploads,
 * rendered from the /history endpoint's nested JSON) has been replaced by the
 * view-backed FindingsPanel, which shows one card per check — grouped components,
 * enriched AL data, filters, per-check "View details", and a downloadable PDF
 * report. FindingsPanel is now the entire tab.
 */
function HistoryTab() {
    // Heading/subtitle removed — the module heading + tabs (in ExportControlWrapper)
    // already title this view, so the tab goes straight to content.
    return (
        <div className="history-container">
            <FindingsPanel />
        </div>
    );
}

export default HistoryTab;
